export const styles = {
  buttonWrapper: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
    p: '11px 20px',
    width: '100%',
  },
};
